/* eslint-disable no-console */

const isDef = v => v !== undefined

class Socket {
  constructor(options) {
    this.options = Object.assign({}, {
      url: '',
      reconnect: true,
      interval: 1000,
      retrys: 5,
    }, options)
    this.retrys = 0
    this.events = {}
  }

  connect() {
    this.ws = new WebSocket(this.options.url)
    this.ws.onerror = (...args) => {
      ++this.retrys
      this.fire('error', ...args)
    }
    this.ws.onclose = (...args) => {
      this.fire('close', ...args)
      if (this.options.reconnect) {
        if (this.retrys < this.options.retrys) {
          setTimeout(() => {
            console.log('Socket reconnecting...')
            this.connect()
          }, this.options.interval)
        } else
          console.warn(`Socket tried to connect ${this.retrys} times. Failed to connect`)
      }
    }
    this.ws.onopen = (...args) => {
      this.retrys = 0
      console.log('Socket connected.')
      this.fire('open', ...args)
    }
    this.ws.onmessage = data => {
      let payload = null
      if (data && data.data)
        payload = JSON.parse(data.data)
      this.fire('message', payload, data)
    }
  }

  on(event, fn) {
    this.events[event] = this.events[event] || []
    this.events[event].push(fn)
  }

  fire(event, ...args) {
    if (this.events[event])
      this.events[event].forEach(fn => fn(...args))
  }

  send(obj) {
    this.ws.send(JSON.stringify(obj))
  }
}

// Install function for Vue
Socket.install = function (Vue, options) {
  Vue.mixin({
    beforeCreate() {
      if (isDef(this.$options.socket)) {
        this._socketRoot = this
        this._socketRoot._socket = this.$options.socket
      } else
        this._socketRoot = (this.$parent && this.$parent._socketRoot) || this
    },
  })

  Object.defineProperty(Vue.prototype, '$socket', {
    get() { return this._socketRoot._socket },
  })
}

export default Socket



// WEBPACK FOOTER //
// ./client/src/websocket.js